// 巡检平台接口——跨域
import request, { IWorkspaceResponse } from './http/Xrequest '

export interface IconItem {
  id: number;
  scenarioId: number;
  iconId: number;
  iconName: string;
  longitude: number;
  latitude: number;
  altitude: number;
  color: string;
  type: number;
  dataType: number;
  path: string;
  downloadUrl: string;
  parentId: number;
  mapInfo: {};
  scale: number;
  rotate: number;
  showNameOnMap: true;
  ignoreOcclusion: true;
  loopMove: true;
  moveSpeed: number;
  speedUnit: string;
  sportPath: {
    path: string[];
  };
  childItems: IconItem[];
}

export interface ScenarioBody {
  id?: number;
  name?: string;
  mapInfo?: {};
  creator?: string;
  createBy?: string;
  lockStatus?: number;
  showStatus?: number;
  createTime?: string;
  iconItems?: IconItem[];
}

export interface SecenarioSearch {
  name?: string;
  lockStatus?: number;
  showStatus?: number;
  orderByField?: string;
  orderBy?: string;
}

export interface SecenarioAddBody {
  name?: string;
}

export interface SecenarioIconSearchBody {
  page: number,
  pageSize: number,
  param?: {
    name?: string,
    categoryId?: number,
    iconType?: string,
    isFavorite?: boolean
  }
}

export interface SandboxIcon {
  name: string,
  objectKey: string,
  categoryId: number,
  iconType: string,
  isSystem?: number,
  createBy?: string
}

/** 场景预案列表 */
export const getSandboxScenarioList = async function (
  body: SecenarioSearch,
): Promise<IWorkspaceResponse<ScenarioBody[]>> {
  const url = '/business/sandbox/scenario/list'
  const result = await request.post(url, body)
  return result.data
}

/** 新增场景预案 */
export const addSandboxScenario = async function (body:SecenarioAddBody):Promise<IWorkspaceResponse<any>> {
  const url = '/business/sandbox/scenario'
  const result = await request.post(url, body)
  return result.data
}

/** 修改场景预案 */
export const sandboxScenarioUpdate = async function (body: ScenarioBody):Promise<IWorkspaceResponse<any>> {
  const url = '/business/sandbox/scenario/edit'
  const result = await request.post(url, body)
  return result.data
}

/** 删除场景预案 */
export const sandboxScenarioDel = async function (id:number|string):Promise<IWorkspaceResponse<any>> {
  const url = `/business/sandbox/scenario/${id}`
  const result = await request.delete(url)
  return result.data
}

/** 场景预案详情 */
export const sandboxScenarioDetail = async function (id:number|string):Promise<IWorkspaceResponse<any>> {
  const url = `/business/sandbox/scenario/${id}`
  const result = await request.get(url)
  return result.data
}

/** 查询图标分类列表 */
export const sandboxScenaroIconCategoryList = async function ():Promise<IWorkspaceResponse<any>> {
  const url = '/business/sandbox/icon/category/list'
  const result = await request.get(url)
  return result.data
}

/** 分页查询图标 */
export const sandboxScenarioIconList = async function (body:SecenarioIconSearchBody):Promise<IWorkspaceResponse<any>> {
  const url = '/business/sandbox/icon/page'
  const result = await request.post(url, body)
  return result.data
}

/** 新增图标 */
export const addSandboxScenarioIcon = async function name (params:SandboxIcon):Promise<IWorkspaceResponse<any>> {
  const url = '/business/sandbox/icon'
  const result = await request.post(url, params)
  return result.data
}

/** 删除图标 */
export const sandboxScenarioIconDel = async function (id:number|string):Promise<IWorkspaceResponse<any>> {
  const url = `/business/sandbox/icon/${id}`
  const result = await request.delete(url)
  return result.data
}

/** 图标更新 */
export const sandboxScenarioIconUpdate = async function (params:SandboxIcon):Promise<IWorkspaceResponse<any>> {
  const url = '/business/sandbox/icon'
  const result = await request.put(url, params)
  return result.data
}

/** 图标收藏 */
export const sandboxScenarioIconFavorite = async function (iconId:number|string):Promise<IWorkspaceResponse<any>> {
  const url = `/business/sandbox/icon/favorite/${iconId}`
  const result = await request.post(url)
  return result.data
}

/** 图标取消收藏 */
export const sandboxScenarioIconCancelFavorite = async function (iconId:number|string):Promise<IWorkspaceResponse<any>> {
  const url = `/business/sandbox/icon/favorite/${iconId}`
  const result = await request.delete(url)
  return result.data
}

/** 获取图标详情 */
export const sandboxScenarioIconDetail = async function (iconId:number|string):Promise<IWorkspaceResponse<any>> {
  const url = `/business/sandbox/icon/${iconId}`
  const result = await request.get(url)
  return result.data
}
